import AppPageTemplate from '@/components/templates/AppPageTemplate';
import { Text, VStack } from '@chakra-ui/react';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/peer-support/$/')({
  // shouldn't ever be shown because of `beforeLoad`, but, just in case...
  staticData: { title: 'Peer Support' },
  component: () => (
    <AppPageTemplate headerHidden>
      <VStack>
        <Text
          marginTop={'20px'}
          variant={'loraTitle'}
          color={'text.darkBlue'}
          fontSize={'26px'}
          lineHeight={'34px'}
          fontWeight={'400'}
        >
          Redirecting...
        </Text>
      </VStack>
    </AppPageTemplate>
  ),

  beforeLoad: async () => {
    throw redirect({
      to: '/organization/dashboard/peer-support',
    });
  },
});
